import $ from "jquery";
import Tag from "@core/components/tag/tag";
import SwapBackground from "@core/base/scripts/classes/swap-background/swap-background";

export default class BaseCard {
  constructor(container) {
    this.selector = ".base-card";
    this.container = container;
    this.elements;
    this._name;
    this.disableClick = false;
    this.$innerBtns;
  }

  init(callback) {
    this.elements = $(this.selector, this.container);
    this.$innerBtns = this.elements.find('button, [role="button"]');
    this.$background = $("[data-img-default]", this.elements);
    this.$tag = $(".tag", this.elements);

    if (this.elements.length > 0 && this.container) {
      console.log(
        this.elements.length +
          " occurences of " +
          this.selector +
          " initialized in :" +
          this.container.attr("class")
      );
    }

    if (this.hasTag()) {
      setTimeout(() => {
        const tag = new Tag(this.elements);
        tag.init();
      }, 100);
    }

    if (this.hasBackground()) {
      const $images=$("[data-img-default]", this.elements);
      $images.each(function(){
        const swapBackground = new SwapBackground($(this));
        swapBackground.init();
      });
    }

    if (callback) {
      console.log(
        "Base card ready",
        this.selector,
        "ocurrences",
        this.elements.length
      );

      this.elements.addClass("base-card--ready");
      callback(this);
    }
  }

  onClick(callback) {
    this.$innerBtns.on("click", e => {
      if (callback && !this.disableClick) {
        e.preventDefault();
        callback($(e.currentTarget));
      }
    });
  }

  set name(str) {
    this._name = str;
  }

  get name() {
    return this._name;
  }

  getHeight() {
    return this.elements.height();
  }

  setHeight(h) {
    this.elements.height(h);
  }

  hasTag() {
    return this.$tag.length > 0;
  }

  hasBackground() {
    return this.$background.length > 0;
  }
}
